/* eslint-disable jsx-a11y/iframe-has-title */
import React from "react";
import { FiMapPin, FiPhone } from "react-icons/fi";

const Contact = () => {
  return (
    <main className="contact-page page-width">
      <section className="contact-map reveal">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3117.54241482782!2d27.4122298151735!3d38.613401079615365!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14b99d8b370f6bb1%3A0x566748b5f8520f5!2zRHIuVMO8bGF5IFnEsWxkxLFyxLFt!5e0!3m2!1str!2str!4v1661453241548!5m2!1str!2str"
          height="450"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </section>
      <section className="contact-details">
        <div className="contact-detail reveal">
          <span><FiMapPin /></span>
          <p>
            Tevfikiye Mahallesi 3813 Sokak Öğretmenler Apartmanı No:31 İçkapı
            No:2, 45120 Yunusemre/Manisa
          </p>
        </div>
        <a className="contact-detail reveal" href="tel:+905304292306">
          <span><FiPhone /></span>
          <p>0530 429 23 06</p>
        </a>
      </section>
    </main>
  );
};

export default Contact;
